import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';
import { Provider } from 'src/app/models/administration/provider';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';

@Injectable({
  providedIn: 'root'
})
export class ProviderServiceService {
  private urlPostTerceros: string = `${EndpointDictionary.Provider.CRUD_PROVIDER_DATA}`

  constructor(
    private message: MessageService,
    private http: HttpService,
    private router: Router,
  ) { }

  public async addProvider(form: Provider){
    this.message.openLoading('Cargando','Creando Tercero')
    this.http.postData(this.urlPostTerceros, form).subscribe(
      (res: BaseResponse<GenericResponse>) => {
      //  //console.log(res)
        if (res['code'] === 0) {
          this.message.SuccessToast('tercero creado correctamente')
          setTimeout(() => {
            this.message.closeLoading()
            this.router.navigate(['administracion/terceros'])
          }, 500);
        } else {
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
          this.message.closeLoading()
        }
      },
      err => {
        this.message.Error('Error!', err.message)
        this.message.closeLoading()
      }
    )

  }

  public async updateProvider(form:Provider) {
    this.message.openLoading('Cargando','Actualizando Tercero')
      this.http.putData(this.urlPostTerceros, form).subscribe(
        (res: BaseResponse<GenericResponse>) => {
          if (res['code'] === 0) {
            this.message.SuccessToast('tercero actualizado correctamente')
            setTimeout(() => {
              this.message.closeLoading()
              this.router.navigate(['administracion/terceros'])
            }, 500);
          } else {
            this.message.Error('Error!', `Codigo: ${res['code']} - Mensaje : ${res['code']}`)
            this.message.closeLoading()
          }
        },
        err => {
          this.message.Error('Error!', err.message)
          this.message.closeLoading()
        }
      )
  }
}
